import styled from "styled-components";

export const WrapperContainer = styled.div`
  background: #f3f1ed;
  height: calc(100vh - 60px);
  @media (max-width: 1024px) {
    height: auto;
  }
  .icon-down-slider {
    display: none;
    @media (max-width: 1024px) {
      display: block;
      margin: 0 auto;
      padding: 0 0 125px;
      width: 100%;
      max-width: 74px;
    }
  }
`;

export const Container = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  height: 100%;

  .slide-item {
    height: calc(100vh - 60px);
    width: 729px;
  }

  .container {
    height: 100%;
    padding: 170px 80px 250px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 1920px) and (max-height: 950px) {
      padding: 110px 80px;
    }
    @media (max-width: 1920px) and (max-height: 713px) {
      padding: 50px 80px;
    }
    @media (max-width: 1600px) {
      padding: 110px 80px;
    }

    .click {
      display: block;
      margin-left: auto;
      max-width: 100px;
      margin-bottom: 60px;
    }

    .wp-logo {
      height: 92px;
      display: flex;
      align-items: center;
    }

    .content {
      margin-top: auto;
      .title {
        color: #a7a7a7;
        letter-spacing: 1px;
        font-family: "Noto Sans KR";
        font-weight: 500;
        font-size: 28px;
        line-height: 55px;
      }

      .subtitle {
        color: #a7a7a7;
        font-family: "Noto Sans KR";
        font-weight: 350;
        font-size: 22px;
        line-height: 32px;
      }
    }

    .head-slider {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 567px;

      .item-head {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 170px;
        @media (max-width: 1920px) and (max-height: 950px) {
          top: 110px;
        }
        @media (max-width: 1920px) and (max-height: 713px) {
          top: 50px;
        }
        @media (max-width: 1600px) {
          top: 110px;
        }
        > img {
          display: block;
          margin: 37px auto 0;
        }
        > div {
          transform: rotate(90deg);
          font-family: "DM Sans";
          font-weight: 500;
          font-size: 28px;
          width: 220px;
          margin-top: 195px;
          margin-left: -30px;
        }
      }
    }
  }

  .active {
    .container {
      .head-slider {
        display: none;
      }
    }
  }
`;

export const ContainerMobile = styled.div`
  min-height: 796px;

  .container-mobile {
    height: 100%;
    padding: 37px 27px 53px;
    position: relative;
    display: flex;
    flex-direction: column;

    .click {
      display: block;
      margin-left: auto;
      max-width: 72px;
    }

    .wp-logo {
      height: 81px;
      display: flex;
      align-items: center;
      margin-top: 48px;
      .logo {
        max-width: 212px;
      }
    }

    .content {
      margin-top: auto;

      .title {
        color: #5b5b5b;
        letter-spacing: 1px;
        font-family: "Noto Sans KR";
        font-weight: 500;
        font-size: 24px;
        padding-bottom: 8px;
      }

      .subtitle {
        color: #5b5b5b;
        font-family: "Noto Sans KR";
        font-weight: 350;
        font-size: 18px;
      }
    }

    .head-slider {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 377px;
      .item-head {
        display: flex;
        align-items: center;
        min-height: 107px;
        padding: 57px;
        @media (max-width: 390px) {
          padding: 10px 20px;
        }

        > div {
          font-family: "DM Sans";
          font-weight: 500;
          font-size: 28px;
          text-align: left;
          padding-left: 25px;
        }

        > img {
          transform: rotate(-90deg);
        }
      }
    }
  }

  .active {
    .container-mobile {
      .head-slider {
        display: none;
      }
    }
  }
`;
